import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultInput from "../../inputs/defaultInput";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import {
  createDepartment,
  getDepartmentDetail,
  updateDepartment,
} from "../../../../services/workspace/department.service";
import { _updateDepartment } from "../../../../store/slices/baseSetup.slice";
import { _fetchDepartments } from "../../../../store/actions/configuration";
import { useDispatch } from "react-redux";
import {
  createFolder,
  updateFolder,
} from "../../../../services/workspace/fileManager.service";
import { HiOutlineFolderOpen } from "react-icons/hi";

const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  parent_id: Yup.string().trim(),
});

const FolderForm = ({
  isModal = false,
  closeModal = () => null,
  id = null,
  editFolder = null,
  refresh = false,
  setRefresh = () => null,
}) => {
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(editFolder);
  const dispatch = useDispatch();

  // useEffect(() => {
  //     if (id) {
  //         if (!pathname.includes("manage-departments")) return
  //         setLoading(true);
  //         getDepartmentDetail(id)
  //             .then((response) => {
  //                 setLoading(false);
  //                 setData(response);
  //             })
  //             .catch((error) => {
  //                 toast.error("Failed to fetch the department data!");
  //                 console.log(error);
  //             });
  //     }
  // }, [id, pathname]);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      name: data?.name || "",
      parent_id: data?.parent_id || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);
     if(editFolder){
      updateFolder(editFolder.uuid, values)
      .then((response) => {
        if (isModal) {
          if (response) {
            closeModal();
            setRefresh(!refresh);
            toast.success("Folder updated successfully!");
          } else {
            closeModal();
            toast.error("Failed to update folder!");
          }
        }
        else{
          setRefresh(!refresh);
          toast.success("Folder updated successfully!");
          navigate("/file-manager");
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        toast.error("Failed to update folder!");
      })
     }
      else{
      createFolder(values)
        .then((response) => {
          if (isModal) {
            if (response) {
              // const payalod = { label: response?.name, value: response?.id, ...response }
              closeModal();
              setRefresh(!refresh);
              toast.success("Folder created successfully!");
            } else {
              closeModal();
              toast.error("Failed to create folder!");
            }
          } else {
            setRefresh(!refresh);
            toast.success("Folder created successfully!");
            navigate("/file-manager");
          }
        })
        .catch((error) => {
          setIsSubmitting(false);
          toast.error(
            "Failed to create folder!" + error.response.data?.message
          );
        });
      }
    },
  });

  useEffect(() => {
    if (id) {
     setFieldValue("parent_id", id);
    }
  }, [id]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div
          className={`bg-white ${isModal ? "p-0" : "p-4"} flex flex-col gap-4`}
        >
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className={"grid grid-cols-1 gap-4 gap-y-2"}>
              {id && (
                <DefaultInput
                  isHidden={true}
                  label={"Parent"}
                  name="parent_id"
                  value={values.parent_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.parent_id && errors.parent_id
                      ? errors.parent_id
                      : ""
                  }
                  required
                />
              )}
           
              <DefaultInput
                label={"Folder Name"}
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && errors.name ? errors.name : ""}
                required
              />
            </div>
            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name={"Submit"}
                type="submit"
                loading={isSubmitting}
              />
              {isModal ? (
                <DefaultButton
                  variant="secondary"
                  name={"Close"}
                  onClick={closeModal}
                />
              ) : null}
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default FolderForm;
